/**
 * What a customer is told when the flow read fails (PRE-3534 / Rule 5).
 *
 * Two surfaces meet the same failed read: `CloudflareFlowScreens` when the
 * read breaks under a mounted flow, and the Integrate step when the read for
 * the resumed domain key fails before anything mounts. One fact, one wording.
 */
export const FLOW_READ_ERROR_MESSAGE = 'We could not read your Cloudflare setup';

export const FLOW_READ_ERROR_DESCRIPTION = 'Reload the page to try again.';

/** The way out of a read that keeps failing. Only the Integrate step can offer it: it owns the domain key. */
export const FLOW_READ_ERROR_ESCAPE_ACTION = 'Start over with another domain';
